

export default function ResultsSection() {
  const scrollToDiagnostic = () => {
    const element = document.getElementById('diagnostico');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const testimonials = [
    {
      name: 'Carlos Silva',
      company: 'TechStart Solutions',
      role: 'CEO',
      image: 'https://readdy.ai/api/search-image?query=Professional%20business%20executive%2C%20confident%20CEO%2C%20modern%20office%20background%2C%20corporate%20headshot%2C%20professional%20attire%2C%20trustworthy%20appearance&width=100&height=100&seq=testimonial-1&orientation=squarish',
      content: 'A M4 Digital transformou completamente nosso processo de vendas. Em 3 meses, aumentamos nossa receita em 280% com as automações de IA.',
      result: '+280% em receita',
      metric: 'R$ 2.8M em novos negócios'
    },
    {
      name: 'Ana Costa',
      company: 'Digital Marketing Pro',
      role: 'Diretora Comercial',
      image: 'https://readdy.ai/api/search-image?query=Professional%20businesswoman%2C%20marketing%20director%2C%20confident%20female%20executive%2C%20modern%20corporate%20environment%2C%20professional%20headshot&width=100&height=100&seq=testimonial-2&orientation=squarish',
      content: 'O tráfego pago inteligente da M4 reduziu nosso CAC em 60% enquanto triplicou a qualidade dos leads. Resultados impressionantes!',
      result: '-60% no CAC',
      metric: '3x mais leads qualificados'
    },
    {
      name: 'Roberto Mendes',
      company: 'E-commerce Plus',
      role: 'Fundador',
      image: 'https://readdy.ai/api/search-image?query=Successful%20entrepreneur%2C%20e-commerce%20business%20owner%2C%20confident%20male%20executive%2C%20modern%20workspace%2C%20professional%20business%20portrait&width=100&height=100&seq=testimonial-3&orientation=squarish',
      content: 'As automações no WhatsApp revolucionaram nosso atendimento. Agora vendemos 24h por dia com conversão de 45% nos chats automatizados.',
      result: '+45% conversão',
      metric: 'Vendas 24/7 automatizadas'
    }
  ];

  const stats = [
    { number: '+1.200', label: 'Empresas Transformadas', icon: 'ri-building-line' },
    { number: '+300%', label: 'Crescimento Médio', icon: 'ri-arrow-up-line' },
    { number: '24h', label: 'Implementação Rápida', icon: 'ri-time-line' },
    { number: '98%', label: 'Satisfação dos Clientes', icon: 'ri-heart-line' }
  ];

  return (
    <section className="py-16 lg:py-20 bg-gray-50" id="resultados">
      <div className="container px-4">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 lg:mb-6">
            Resultados que
            <span className="gradient-text-orange"> Comprovam</span>
          </h2>
          <p className="text-lg lg:text-xl text-gray-600 leading-relaxed">
            Veja como empresas como a sua estão alcançando crescimento exponencial com nossas soluções
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 mb-12 lg:mb-16">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="w-12 h-12 lg:w-16 lg:h-16 bg-gradient-to-r from-orange-500 to-red-500 rounded-full flex items-center justify-center mx-auto mb-3 lg:mb-4">
                <i className={`${stat.icon} text-white text-lg lg:text-2xl`}></i>
              </div>
              <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-1 lg:mb-2">
                {stat.number}
              </div>
              <div className="text-sm lg:text-base text-gray-600 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        {/* Testimonials */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mb-12 lg:mb-16">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-2xl p-6 lg:p-8 shadow-lg border border-gray-200 card-hover hover:shadow-orange-100">
              {/* Quote */}
              <div className="mb-4 lg:mb-6">
                <i className="ri-double-quotes-l text-3xl lg:text-4xl text-orange-500 mb-3 lg:mb-4"></i>
                <p className="text-sm lg:text-base text-gray-700 leading-relaxed">
                  {testimonial.content}
                </p>
              </div>
              
              {/* Results */}
              <div className="bg-gradient-to-r from-orange-50 to-red-50 rounded-lg p-3 lg:p-4 mb-4 lg:mb-6">
                <div className="text-lg lg:text-2xl font-bold gradient-text-orange mb-1">
                  {testimonial.result}
                </div>
                <div className="text-xs lg:text-sm text-gray-600">
                  {testimonial.metric}
                </div>
              </div>
              
              {/* Author */}
              <div className="flex items-center gap-3 lg:gap-4">
                <img 
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover"
                />
                <div>
                  <div className="font-semibold text-gray-900 text-sm lg:text-base">
                    {testimonial.name}
                  </div>
                  <div className="text-xs lg:text-sm text-gray-600">
                    {testimonial.role} • {testimonial.company}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Case Study CTA */}
        <div className="bg-white rounded-2xl p-6 lg:p-12 border border-gray-200 text-center">
          <div className="max-w-2xl mx-auto">
            <h3 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-3 lg:mb-4">
              Quer Ver Mais Cases de Sucesso?
            </h3>
            <p className="text-lg lg:text-xl text-gray-600 mb-6 lg:mb-8">
              Agende uma reunião para conhecer cases detalhados e estratégias que geraram milhões em vendas
            </p>
            <div className="flex justify-center">
              <button 
                onClick={scrollToDiagnostic}
                className="btn-primary-orange text-sm lg:text-base cursor-pointer"
              >
                <i className="ri-video-line mr-2"></i>
                Agendar Reunião
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

